export default {"src":"/_next/static/media/KMB.c0530bb7.svg","height":18,"width":18};